import './Home.css';

const WA = 'https://wa.me/34614807628?text=Hola!%20Quiero%20reservar%20en%20NEON%20Music%20Cocktail';

export default function Contacto() {
  return (
    <main>
      <section className="nh-section" aria-labelledby="contacto-title">
        <div className="nh-section-head">
          <h1 id="contacto-title" className="nh-section-title">
            Contacto y reservas
          </h1>
          <p className="nh-section-sub">
            NEON Music Cocktail & Pub en Alcalá de Henares.
          </p>
        </div>

        <div className="nh-loc-inner">
          <div>
            <ul className="nh-loc-list">
              <li className="nh-loc-item">
                <div>
                  <p className="nh-loc-label">Dirección</p>
                  <p className="nh-loc-value">C. de la Coruña, 16<br />28805 Alcalá de Henares, Madrid</p>
                </div>
              </li>
              <li className="nh-loc-item">
                <div>
                  <p className="nh-loc-label">Teléfono</p>
                  <p className="nh-loc-value"><a href="tel:+34614807628">614 80 76 28</a></p>
                </div>
              </li>
              <li className="nh-loc-item">
                <div>
                  <p className="nh-loc-label">Reservas</p>
                  <p className="nh-loc-value">
                    <a href={WA} target="_blank" rel="noreferrer">Enviar WhatsApp</a>
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <p className="nh-loc-label" style={{ marginBottom: '1.25rem' }}>Horario</p>
            <div className="nh-schedule-grid">
              <span className="nh-schedule-day">Horario</span>
              <span className="nh-schedule-time">09:00 — 02:00</span>
              <span className="nh-schedule-day">Fines de semana</span>
              <span className="nh-schedule-time">09:00 — 02:30</span>
              <span className="nh-schedule-day">Festivos</span>
              <span className="nh-schedule-time">09:00 — 02:30</span>
            </div>
            <a
              href="https://maps.app.goo.gl/7dk9DCQMa6b3cbE5A"
              target="_blank"
              rel="noreferrer"
              className="nh-map-btn"
              style={{ marginTop: '1.5rem' }}
            >
              Cómo llegar
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
